<div class="tsc-dialog">
  <div class="tsc-dialog__header">
    <div class="tsc-dialog__header__icon" [ngClass]="['tsc-dialog__header__icon--' + model.iconColor]">
      <mat-icon fontSet="ta-icons" [fontIcon]="model.icon"></mat-icon>
    </div>
    <div class="tsc-dialog__header__title">
      <span class="typo-ui-h-3">{{ model.title | translate }}</span>
      <span class="typo-ui-text-sm-regular" *ngIf="model.subtitle">{{ model.subtitle | translate }}</span>
    </div>
    <mat-icon *ngIf="model.dismissable" class="tsc-dialog__header__close" fontSet="ta-icons" fontIcon="x" (click)="dismiss()"></mat-icon>
  </div>
  <div class="tsc-dialog__content">
    <span class="typo-ui-text-md-regular tsc-rich-text" [innerHTML]="model.description | translate"></span>
  </div>
  <div class="tsc-dialog__actions">
    <ta-button size="md" *ngIf="model.dismissable" (click)="dismiss()" appearance="outline" color="neutral">{{ model.dismissLabel | translate }}</ta-button>
    <ta-button size="md" (click)="confirm()" color="danger">{{ model.okLabel | translate }}</ta-button>
  </div>
</div>
